import { render, staticRenderFns } from "./BasicOperations1.vue?vue&type=template&id=f3387d36&scoped=true&"
import script from "./BasicOperations1.vue?vue&type=script&lang=js&"
export * from "./BasicOperations1.vue?vue&type=script&lang=js&"
import style0 from "./BasicOperations1.vue?vue&type=style&index=0&id=f3387d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3387d36",
  null
  
)

export default component.exports